import React from 'react'

import { Typography } from 'antd'

import { useTheme } from 'common/hooks/use-theme'

type ItemTitleProps = {
  text: string
}

export const ItemTitle = ({ text }: ItemTitleProps) => {
  const theme = useTheme()
  return <Typography.Text style={{ color: theme.colors['gray-7'] }}>{text}</Typography.Text>
}
